<template>
  <!-- class="ts-relative ts-flex ts-w-full ts-flex-wrap ts-items-stretch ts-mb-3" -->
  <!-- <div
  > -->
  <!-- <input
      v-model="model.text"
      type="text"
      placeholder="Search:serial,product name-grade"
      class="
        ts-px-3
        ts-py-3
        ts-placeholder-blueGray-300
        ts-text-blueGray-600
        ts-relative
        ts-bg-white
        ts-rounded
        ts-text-sm
        ts-border
        ts-outline-none
        focus:ts-outline-none focus:ts-ring
        ts-w-full ts-pr-10
      "
    /> -->
  <!-- <span
      class="
        ts-z-10
        ts-h-full
        ts-leading-snug
        ts-font-normal
        ts-absolute
        ts-text-center
        ts-text-blueGray-300
        ts-bg-transparent
        ts-rounded
        ts-text-base
        ts-items-center
        ts-justify-center
        ts-w-8
        ts-right-0
        ts-pr-3
        ts-py-3
      "
    >
      <i class="fas fa-search"></i>
    </span> -->
  <a-select
    v-model="model.product_id"
    mode="multiple"
    placeholder="Search:product name|barcode"
    :loading="on_search_product"
    @search="onProductSearch"
    @change="onSelectChange"
    :show-arrow="false"
    :filter-option="true"
    :not-found-content="null"
    :filterOption="
      (input, option) =>
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
    "
    class="ts-w-full"
  >
    <a-select-option
      v-for="product in productList"
      :key="product.product_id"
      :value="product.product_id"
    >
      {{ product.product_name_en }}
    </a-select-option>
  </a-select>
  <!-- </div> -->
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: ['value'],
  data() {
    return {
      productList: [],
      on_search_product: false,
      model: {
        product_id: [],
      },
    }
  },
  methods: {
    ...mapActions('product/label', ['getProductProfile']),
    onProductSearch:  _.debounce(function(value) {
        this.on_search_product = true
        this.getProductProfile({
          text_search: value,
          ex_pid: this.productList.map(el => el.product_id),
        })
        .then(response => {
          this.productList.push(...response.data);
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.on_search_product = false
        })

    }, 1000),
    onSelectChange(){
      this.$emit('input', this.model.product_id)
    }
  },
}
</script>